module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "project-show leads-listing"
  }, [_c('lead-create', {
    attrs: {
      "id": _vm.id
    }
  }), _vm._v(" "), (this.emptyState === 'leads') ? _c('empty-state', {
    attrs: {
      "name": "leads",
      "heading": _vm.emptyStateHeading,
      "subtitle": _vm.emptyStateSubtitle,
      "button": true
    }
  }) : _c('div', [_c('div', {
    staticClass: "search-container"
  }, [_c('searchbar', {
    attrs: {
      "value": _vm.query.search,
      "model": _vm.model
    },
    on: {
      "search": _vm.search
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "filter-trigger icon yule-icon-settings",
    attrs: {
      "title": _vm.$t('ui.filters.hint')
    },
    on: {
      "click": function($event) {
        _vm.filterDisplay = !_vm.filterDisplay
      }
    }
  })], 1), _vm._v(" "), _c('transition', {
    attrs: {
      "name": "test"
    }
  }, [(_vm.filterDisplay && _vm.query.filters) ? _c('leads-filtering', {
    attrs: {
      "filters": _vm.query
    },
    on: {
      "apply": _vm.filterUpdate,
      "reset": _vm.filterReset
    }
  }) : _vm._e()], 1), _vm._v(" "), _c('div', {
    staticClass: "leads-listing--desktop"
  }, [_c('leads-listing', {
    attrs: {
      "loading": _vm.loading,
      "data": _vm.items,
      "structure": _vm.correctedStructure,
      "params": {
        project_id: _vm.id,
        global_sorting: true,
        sort_by: this.query.sort_by,
        sort_order: this.query.sort_order
      },
      "model": "project_lead",
      "has_searched": _vm.has_searched
    },
    on: {
      "sorting": _vm.sorting,
      "itemDelete": _vm.itemDelete
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "leads-listing--mobile"
  }, [_c('leads-listing', {
    attrs: {
      "loading": _vm.loading,
      "data": _vm.items,
      "structure": _vm.structure_mobile,
      "params": {
        project_id: _vm.id,
        global_sorting: true,
        sort_by: this.query.sort_by,
        sort_order: this.query.sort_order
      },
      "model": "project_lead",
      "has_searched": _vm.has_searched
    },
    on: {
      "sorting": _vm.sorting,
      "itemDelete": _vm.itemDelete
    }
  })], 1), _vm._v(" "), (!_vm.loading) ? _c('pagination', {
    attrs: {
      "page": _vm.page,
      "total-pages": _vm.total_pages
    },
    on: {
      "goToPage": _vm.goToPage
    }
  }) : _vm._e()], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-3a91d16c","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/pages/project/leads/Leads.vue
// module id = 1873
// module chunks = 0